export default __webpack_public_path__ + "static/media/gold.34e1db0e.jpg";